import React from 'react';
import useStore from '../../stores/store';
import PostMessage from '../next-page-components/PostMessage';

const campaignTexts = {
  npAdmin: {
    fundraiserFormHeader: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        {/* <ol className="list-inside list-decimal space-y-8"> */}
        <li>Launch a campaign to raise funds for a specific project.</li>
        <li>
          Choose a project from your existing projects list, identify your
          target audience and campaign details. Once you click create, the
          campaign will appear on the social feed.
        </li>
        <li className="list-none">
          <PostMessage
            message="In the US, all donations that are made through Neki, are voluntary and
          facilitated exclusively via Stripe. These donations are directed to
          nonprofit organizations that have claimed their profile on Neki and
          have integrated with Stripe. For nonprofit organizations that have
          either not claimed their profile on Neki or have claimed their profile
          but have not integrated with Stripe, the donation process differs.
          Donors will be redirected to the nonprofit's external website to
          complete their donations. In India, donations are directly made to the
          Non-profits. Fundraising is free on Neki. We don't charge our
          donors or the charities."
          />
        </li>
      </ol>
    ),
    p2pFundraiserFormHeader: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        {/* <ol className="list-inside list-decimal space-y-8"> */}
        <li>Launch a campaign to raise funds for a specific project.</li>
        <li>
          Choose a project from your existing projects list, identify your
          target audience and campaign details. Once you click create, the
          campaign will appear on the social feed.
        </li>
        <li className="list-none">
          <PostMessage
            message="In the US, all donations that are made through Neki, are voluntary and
          facilitated exclusively via Stripe. These donations are directed to
          nonprofit organizations that have claimed their profile on Neki and
          have integrated with Stripe. For nonprofit organizations that have
          either not claimed their profile on Neki or have claimed their profile
          but have not integrated with Stripe, the donation process differs.
          Donors will be redirected to the nonprofit's external website to
          complete their donations. In India, donations are directly made to the
          Non-profits. Fundraising is free on Neki. We don't charge our
          donors or the charities."
          />
        </li>
      </ol>
    ),
    inKindFundraiserFormHeader: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        <li>
          Launch a campaign to collect goods and supplies for a specific
          project.
        </li>
        <li>
          Choose an in-kind project from your existing projects list, identify
          your target audience and campaign details. Once you click create, the
          campaign will appear on the social feed.
        </li>
        <li className="list-none">
          Neki recommend creating In-Kind fundraisers for companies that are
          close to your current location.
          {/* <PostMessage
            message="Neki recommend creating In-Kind fundraisers for companies that are
          close to your current location."
          /> */}
        </li>
      </ol>
    ),
  },
  default: {
    fundraiserFormHeader: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        <li>Select a Nonprofit from our list of registered charities</li>
        <li>Launch your fundraiser and share it with your colleagues</li>
        <li>Make an impact.</li>
        <li className="list-none">
          <PostMessage
            message="In the US, all donations that are made through Neki, are voluntary and
          facilitated exclusively via Stripe. These donations are directed to
          nonprofit organizations that have claimed their profile on Neki and
          have integrated with Stripe. For nonprofit organizations that have
          either not claimed their profile on Neki or have claimed their profile
          but have not integrated with Stripe, the donation process differs.
          Donors will be redirected to the nonprofit's external website to
          complete their donations. In India, donations are directly made to the
          Non-profits. Fundraising is free on Neki. We don't charge our
          donors or the charities."
          />
        </li>
      </ol>
    ),
    p2pFundraiserFormHeader: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        <li>Select a Nonprofit from our list of registered charities</li>
        <li>
          Launch your peer to peer fundraiser and share it with your colleagues
        </li>
        <li>Make an impact.</li>
        <li className="list-none">
          <PostMessage
            message="In the US, all donations that are made through Neki, are voluntary and
          facilitated exclusively via Stripe. These donations are directed to
          nonprofit organizations that have claimed their profile on Neki and
          have integrated with Stripe. For nonprofit organizations that have
          either not claimed their profile on Neki or have claimed their profile
          but have not integrated with Stripe, the donation process differs.
          Donors will be redirected to the nonprofit's external website to
          complete their donations. In India, donations are directly made to the
          Non-profits. Fundraising is free on Neki. We don't charge our
          donors or the charities."
          />
        </li>
      </ol>
    ),
    inKindFundraiserFormHeader: (
      <ol className="list-inside list-decimal space-y-2 font-dmsans text-15 font-normal">
        <li>Select a Nonprofit from our list of registered nonprofits.</li>
        <li>Select an in-kind project for that nonprofit.</li>
        <li>
          Change the Campaign name to something that personalizes this campaign
          for you and launch it.
        </li>
        <li className="list-none">
          An In-Kind fundraising campaign is used to collect goods and supplies
          to help the cause that the Non-profit is driving on the ground. By
          creating an In-Kind fundraiser you are volunteering to collect and
          deliver the goods and supplies to the Non-profit’s address. We
          recommend creating this In-kind fundraiser for Non-profits that are
          close to your current location only.
          {/* <PostMessage
            message="An In-Kind fundraising campaign is used to collect goods and supplies
          to help the cause that the Non-profit is driving on the ground. By
          creating an In-Kind fundraiser you are volunteering to collect and
          deliver the goods and supplies to the Non-profit’s address. We
          recommend creating this In-kind fundraiser for Non-profits that are
          close to your current location only."
          /> */}
        </li>
      </ol>
    ),
  },
};

const getCampaignText = (key) => {
  const { user } = useStore.getState();
  if (user.isNonProfitAdmin) {
    return campaignTexts.npAdmin[key];
  }
  return campaignTexts.default[key];
};

export default getCampaignText;
